import Hotel from 'arbitrip-common/client/entities/Hotel';

export default Hotel;
